import React from 'react';
import Input from '../../Atoms/Input'
const FormGroup = ({element, label, type, placeholder}) => {
    if(element === "input"){
        return (
            <div className="form-group">
                <Input type={type} placeholder={placeholder}/>
                <p className="help-block text-danger">{label}</p>
            </div>
        );
    }
    if(element === "textarea"){
        return (
            <div className="form-group">
                <textarea className="form-control" placeholder={placeholder} required="required" />
                <p className="help-block text-danger">{label}</p>
            </div>
        )
    }
};

export default FormGroup;